<template>
  <div>
    <template v-if="!isEdit">
      <div class="pa-2" :style="!time.status ? 'background-color: #eee' : ''">
        <v-layout wrap>
          <v-flex xs12 sm4 class="text-xs-left text-sm-center pb-2 pt-2">{{ $t(name) }}</v-flex>
          <v-flex xs6 sm4 class="text-xs-center pb-2 pt-2">{{ openat ? openat : '00:00' }}</v-flex>
          <v-flex xs6 sm4 class="text-xs-center pb-2 pt-2">{{
            closeat ? closeat : '23:59'
          }}</v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </template>
    <template v-else>
      <div v-if="time" class="pa-2">
        <v-layout wrap>
          <v-flex xs12 sm4 class="text-xs-center">
            <v-checkbox
              v-model="time.status"
              color="primary"
              class="mt-0"
              :label="$t(name)"
            ></v-checkbox>
          </v-flex>
          <v-flex xs12 sm4 class="text-xs-center form-control">
            <v-layout wrap>
              <v-flex xs9>
                <multiselect
                  v-model="openat"
                  :options="timeOptions"
                  :allow-empty="false"
                  :searchable="false"
                  select-label
                  selected-label
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs3>
                <v-btn flat fab small class="ma-0" @click="openat = null">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm4 class="text-xs-center form-control">
            <v-layout wrap>
              <v-flex xs9>
                <multiselect
                  v-model="closeat"
                  :options="timeOptions"
                  :allow-empty="false"
                  :searchable="false"
                  select-label
                  selected-label
                  deselect-label
                ></multiselect>
              </v-flex>
              <v-flex xs3>
                <v-btn flat fab small class="ma-0" @click="closeat = null">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
      <v-divider></v-divider>
    </template>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
  components: {
    Multiselect
  },
  inject: ['$validator'],
  props: ['value', 'name', 'isEdit'],
  data() {
    return {
      time: null,
      showOpenat: false,
      showCloseat: false,
      timeOptions: []
    }
  },
  computed: {
    openat: {
      get() {
        if (this.time && this.time.openat) {
          return this.time.openat.split('+')[0]
        } else {
          return '00:00'
        }
      },
      set(value) {
        if (value) {
          this.time.openat = value + '+07'
        } else {
          this.time.openat = '00:00+07'
        }
      }
    },
    closeat: {
      get() {
        if (this.time && this.time.closeat) {
          return this.time.closeat.split('+')[0]
        } else {
          return '24:00'
        }
      },
      set(value) {
        if (value) {
          this.time.closeat = value + '+07'
        } else {
          this.time.closeat = '24:00+07'
        }
      }
    }
  },
  watch: {
    value: function (newVal) {
      this.time = newVal
    }
  },
  created: function () {
    for (let index = 0; index <= 24; index++) {
      this.timeOptions.push(index.toString().padStart(2, '0') + ':00')
      if (index != 24) {
        this.timeOptions.push(index.toString().padStart(2, '0') + ':30')
      }
    }
  },
  mounted: function () {
    this.time = this.value
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/WorkingHours/OpenTimeBotItem.vue